<template>
  <div class="sign">
    <div class="info">
      <van-cell-group inset>
        <van-form ref="form" show-error show-error-message>
          <van-field
            v-model="userInfo.name"
            label="姓名"
            placeholder="请输入姓名"
            :rules="rules.name"
          />
          <van-field
            v-model="userInfo.idNo"
            label="身份证号"
            placeholder="请输入身份证号"
            :rules="rules.idNo"
          />
          <van-field
            v-model="userInfo.mobile"
            label="手机号"
            placeholder="请输入手机号"
            :rules="rules.mobileRules"
          />
          <van-field
            v-model="userInfo.email"
            label="邮箱"
            placeholder="请输入邮箱"
            :rules="rules.email"
          />
        </van-form>
      </van-cell-group>
    </div>
    <div style="text-align: center">
      <van-button
        class="submit-btn"
        :loading="loading"
        loading-text="更换中..."
        @click="handleSubmit"
        :disabled='loading'
      >
        更换保管员
      </van-button>
    </div>
  </div>
</template>

<script>
import { rules } from '../hooks';
import { apiEditSealKeeper } from '@/api/dq.js';
import { Toast } from 'vant';
export default {
  data() {
    return {
      rules,
      userInfo: {},
      loading: false,
      traderId:''
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.form
        .validate()
        .then(() => {
          delete this.userInfo.type;
          let data = {
            ...this.userInfo,
            traderId: this.traderId
          }
          this.loading = true;
          apiEditSealKeeper(data).then((res) => {
            this.loading = false;
            Toast.success('修改成功');
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
          }).catch(err=>{
            setTimeout(() => {
              this.loading = false;
              Toast.fail(err.message)
            }, 2000);
          })
        })
        .catch(() => {
          this.$toast('请填写完整信息');
        });
    },
  },
  mounted() {
    // console.log(this.$route);
    // this.userInfo = this.$route.query;
    this.traderId = this.$route.query.traderId
  },
};
</script>

<style lang="less" scoped>
.sign {
  line-height: 1;
  font-size: 16px;
  background: #f3f5f6;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  text-align: left;
  padding-top: 20px;
  .info {
    .van-cell__title {
      color: #666666;
    }
    .van-cell__value {
      flex: 2;
      text-align: left;
      color: #111111;
    }
  }
}
.icon {
  transform: rotateZ(90deg) scale(0.8);
}

.submit-btn {
  width: 232px;
  text-align: center;
  height: 44px;
  line-height: 44px;
  background: #FF6F00;
  border-radius: 22px;
  color: #fff;
  margin: 40px auto;
}
</style>